<!--
 * @Description: Header用户栏下方-绑定微信浮层
 * @LastEditors: YGQ
 * @LastEditTime: 2026-09-23 18:50:18
-->
<template>
  <!-- 浮层渲染在父级相对定位容器内, 锚定在用户栏下方; 预取二维码就绪后延时渐入, 隐藏渐出 -->
  <transition name="wechat-fade">
    <div v-show="show" class="wechat-popover">
      <div class="popover-card">
        <!-- 微信扫码绑定二维码: visible 时提前挂载预取, 弹出时与浮层同步出现 -->
        <LoginWeChat
          v-if="visible"
          platform="wechat"
          text1="关注服务号"
          text2="接收重要通知推送"
          type="popover"
          api="getThirdPartyBindCode"
          @loaded="onQrLoaded"
          @ok="onBindSuccess"
          @expire="onQrExpire"
        />
      </div>
    </div>
  </transition>
</template>

<script>
import LoginWeChat from "@/components/LoginWeChat";

export default {
  name: "HeaderWeChatPopover",
  components: { LoginWeChat },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      qrReady: false, // 二维码是否已加载完成
      delayElapsed: false, // 展示延时是否已结束
      closing: false, // 是否正在执行渐出动画
      timer: null,
    };
  },
  computed: {
    // 二维码就绪且延时结束后才展示, 保证弹出时二维码与浮层同步出现
    show() {
      return this.qrReady && this.delayElapsed && !this.closing;
    },
  },
  watch: {
    // 提前挂载预取二维码, 延时结束后展示; 隐藏时立即复位
    visible: {
      immediate: true,
      handler(val) {
        clearTimeout(this.timer);
        if (val) {
          this.closing = false; // 关闭过程中重新打开时取消渐出状态
          this.qrReady = false;
          this.delayElapsed = false;
          this.timer = setTimeout(() => {
            this.delayElapsed = true; // 延时展示
          }, 1000);
        } else {
          this.closing = false;
          this.qrReady = false;
          this.delayElapsed = false;
        }
      },
    },
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  methods: {
    /**
     * 二维码加载完成
     */
    onQrLoaded() {
      this.qrReady = true;
    },
    /**
     * 关闭浮层
     */
    close() {
      if (this.closing) return;
      // 先触发渐出动画, 动画结束后再通知父级销毁二维码, 避免内容瞬间消失
      if (this.show) {
        this.closing = true;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.closing = false;
          this.$emit("update:visible", false);
          this.$emit("close");
        }, 300);
      } else {
        this.$emit("close");
      }
    },
    /**
     * 扫码绑定成功
     */
    onBindSuccess() {
      try {
        const user = JSON.parse(localStorage.getItem("user") || "{}");
        user.isSubscribeWx = 1; // 关注公众号即视为已绑定
        localStorage.setItem("user", JSON.stringify(user));
      } catch (err) {
        console.error("更新本地缓存用户信息失败", err);
      }
      // this.$msg.success("绑定成功");
      this.close();
    },
    /**
     * 二维码过期后自动隐藏浮层
     */
    onQrExpire() {
      this.close();
    },
  },
};
</script>

<style scoped>
.wechat-popover {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  z-index: 2000;
}

.popover-card {
  box-sizing: border-box;
  border-radius: 12px;
}

/* 渐入/渐出动画 */
.wechat-fade-enter-active,
.wechat-fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.wechat-fade-enter,
.wechat-fade-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}
</style>
